
export default {
  name: 'ComponentSnackBar',
  data() {
    return {
      show: false,
      message: '',
      prependIcon: '',
      color: ''
    }
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'snackbar/showMessage') {
        this.message = state.snackbar.content
        this.prependIcon = state.snackbar.prependIcon
        this.color = state.snackbar.color
        this.show = true
        // this.$bvToast.toast(state.snackbar.content, {
        //   // autoHideDelay: 5000,
        //   variant: state.snackbar.color,
        //   solid: false,
        //   static: true,
        //   headerClass: 'd-none',
        //   noCloseButton: false
        // })
      }
    })
  }
}
